<form
  *ngIf="form"
  [formGroup]="form"
  [attr.aria-label]="labels?.stellar?.registration?.mobileNumber"
  class="phone-number-container"
>
  <div class="phone-number-row">
    <input type="hidden" formControlName="countryDialCode" />

    <mat-form-field class="country-code-container">
      <!-- TODO -- don't use disabled attribute with reactive forms -->
      <!-- <mat-label class="mg-hide-label">{{ labels?.stellar?.registration?.countryCode }}</mat-label> -->
      <mat-label class="mg-hide-label">{{
        phoneFieldConfig?.fieldLabel!
      }}</mat-label>
      <mat-select formControlName="countryCode">
        <mat-select-trigger class="country-code">
          <span
            *ngIf="form?.controls?.countryCode?.value?.toLowerCase()"
            [attr.class]="
              'sprite-flag country-code-flag ' +
              form.controls.countryCode.value?.toLowerCase()
            "
          ></span>
          <span class="dialing-code">+ {{ getCountryDialingCode() }}</span>
          <img
            src="assets\images\dropdown-arrow-icon.svg"
            class="country-code-dropdown-icon"
            alt="down arrow icon"
          />
        </mat-select-trigger>

        <mat-option
          *ngFor="let country of countries"
          [value]="country.iso2Code"
        >
          <div class="country-div">
            <div class="country-code">
              <!-- <mat-icon [svgIcon]="'flag_' + 'us'"></mat-icon> -->
              <span
                [attr.class]="'sprite-flag ' + country?.iso2Code?.toLowerCase()"
              ></span>
              <span class="dialing-code"
                >+ {{ country.countryDialingCode }} {{ country.name }}</span
              >
            </div>
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="phone-number-container">
      <!-- <mat-label class="mg-hide-label">{{ phoneFieldConfig?.fieldLabel! }}</mat-label> -->
      <input
        matInput
        type="text"
        formControlName="phoneNumber"
        id="phoneNumber"
        mgRestrict="0-9\.\-\s"
        [attr.aria-label]="labels?.stellar?.registration?.mobileNumber"
        onpaste="return false"
      />
      <mat-error *ngIf="form.controls.phoneNumber?.errors?.required">
        {{ labels?.stellar?.registration?.mobileNumber }}
        {{ labels?.stellar?.registration?.errorMsgs.required }}!</mat-error
      >
      <mat-error
        *ngIf="
          form.controls.phoneNumber?.errors?.phoneNumber &&
          !form.controls.phoneNumber?.errors?.required
        "
      >
        {{ labels?.stellar?.registration?.mobileNumber }}
        {{ labels?.stellar?.registration?.errorMsgs.invalid }}!
      </mat-error>
    </mat-form-field>
  </div>
</form>
